export const blocksId = {
    "main": {
        "json": {
            "fullPc": 35189,
            "fullMob": 35189,
            "prevPc": 35189,
            "prevMob": 35189
        },
    },
        
}
